// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3KKlH","addWidgetButton":"Header_addWidgetButton__2n29c","dashboardTabs":"Header_dashboardTabs__2fOJL","active":"Header_active__3VUuX"};